module.exports = __webpack_public_path__ + "static/offset-22ef1f4b9b90b03f303d1c3e4ac10c5e.mp4";